import 'firebase/analytics';
import app from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/messaging';
import 'firebase/database';

import React from 'react';
import { Redirect } from "react-router-dom";
import * as shortlistActions from '../../actions/shorlisted-actions';
import * as notificationActions from '../../actions/notifications-actions'
import { store } from '../../index';
import Globals from '../classes/Globals';
import User from "../classes/User";
import Utils from '../classes/Utils';
import DashboardNotification from '../classes/DashboardNotification';
import FirebaseMessaging from './FirebaseMessaging-custom-sw';





// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const config = {
    apiKey: "AIzaSyC9ZavdeRid-qxciHuLsaCwJEvdjS0_Lbc",
    authDomain: "recruit-zing.firebaseapp.com",
    databaseURL: "https://recruit-zing.firebaseio.com",
    projectId: "recruit-zing",
    storageBucket: "recruit-zing.appspot.com",
    messagingSenderId: "363130057479",
    appId: "1:363130057479:web:8e703f93b138ae921e8ba2",
    measurementId: "G-80CWMHW8F2"
};
const vapidKey = "BBXGZZ3MkGqoRl4j8iGfKShDHbmhLzi0YhxSBEM32zEcFbpM_z2cQbEd5TlqeL4m0_LrT0n5wpLOjtRVFMWqkiI";
let messaging = null;

/*
var configDev = {
  apiKey: "AIzaSyC9ZavdeRid-qxciHuLsaCwJEvdjS0_Lbc",
  authDomain: "recruit-zing.firebaseapp.com",
  databaseURL: "https://recruit-zing.firebaseio.com",
  projectId: "recruit-zing",
  storageBucket: "recruit-zing.appspot.com",
  messagingSenderId: "363130057479",
  appId: "1:363130057479:web:8e703f93b138ae921e8ba2",
  measurementId: "G-80CWMHW8F2"
};
*/

class Firebase extends React.Component {


  static FirebaseInstance = null;
  static FirebaseApp = null;

  Callback = null;

  // listen to responses from client
  clientResponseListener = null;

  // listen to chat messages
  userRoomsRef = null;
  userRoomsListener = null;

  // Track chat initialization state
  roomsArray = null;
  isInitialized = false;

  constructor(props) {
    super( props );

    let currentConfig = config;
    if ( Utils.DevMode() )
    {
      // dev using test database to check rules
      // for telezingdev
     //  currentConfig = configDev;
    }

    /// console.log( "Firebase init" );

    app.initializeApp(currentConfig);

    app.analytics();
    app.firestore();
    app.database();

    app.auth();
    if ( app.messaging.isSupported() )
    {
      app.messaging();
    }

    Globals.FirebaseApp = app;
    Globals.FirebaseInstance = this;

    // not doing anything about success or failure
    app.auth().setPersistence(app.auth.Auth.Persistence.SESSION);
    /*
      .then(() => {
        })
      .catch((error) => {
      });
      */

    app.auth().onAuthStateChanged(function(user) {
      if (user) {


        // User is signed in.

        Globals.FirebaseInstance.clearListeners();
        if ( ! user.isAnonymous )
        {
            Globals.FirebaseInstance.AddShortlistListeners();
            Globals.FirebaseInstance.AddChatListeners(user.uid);
        }

        if ( Globals.FirebaseInstance.PushMessagingSupported() )
        {
          Globals.FirebaseInstance.messaging = new FirebaseMessaging(app, vapidKey, false );
         //  Globals.FirebaseInstance.StartPushNotifications();
        }


/*
        let newUser = new User();

        newUser.Name = "";
        newUser.IsAnonymous = user.isAnonymous;
        newUser.Identifier = user.uid;
        newUser.LoggedInToFirebase = true;
        if ( Utils.HasString( user.email) )
        {
          newUser.Email = user.email;
        }
        newUser.EmailVerified = (user.emailVerified === true);

        // store.dispatch( userActions.replaceUser( newUser) );

        this.state = { redirect: null };

        if ( newUser.IsAnonymous )
        {
          Globals.Storage.RemoveLocal( Globals.FIREBASE_HAS_ACCOUNT );
        }
        else
        {
          Globals.Storage.StoreLocal( Globals.FIREBASE_HAS_ACCOUNT, "1" );
        }

        user.getIdTokenResult(true).then((idTokenResult) => {

         // console.log( 'token result',  idTokenResult );
        //  console.log( idTokenResult.claims );
        //  console.log( user.uid );


          let url = new Urls().UserTokenUrl();
          superagent.post( url )
          .set('Accept', 'application/json')
          .set('Content-Type', 'application/json')
          .set('x-requested-with', 'XMLHttpRequest')
          .send({ "idToken": idTokenResult} )
        //  .use(AuthRequest.AddAuthHeaders)

        .end((error, response) => {

          if ( ! error && response && response.body )
          {

            if ( response.body.successful && response.body.token && response.body.token.length > 0 )
            {
              newUser.UserToken = response.body.token;

              //let updates = { UserToken: response.body.token };

              if ( idTokenResult.claims )
              {
                if ( idTokenResult.claims.email && idTokenResult.claims.email.length > 0 )
                {
                //  updates["Email"] = idTokenResult.claims.email;
                  newUser.Email = idTokenResult.claims.email;
                }
                if ( idTokenResult.claims.email_verified === true )
                {
                  newUser.EmailVerified = idTokenResult.claims.email_verified;
                  // updates["EmailVerified"] = true;
                }
              }

              store.dispatch( userActions.replaceUser( newUser) );

              // store.dispatch( userActions.updateUser( updates ) );
              if ( Globals.FirebaseInstance.Callback && Globals.FirebaseInstance.Callback.AuthStatusChanged )
              {
                Globals.FirebaseInstance.Callback.AuthStatusChanged();
              }
            }
          }
        });

        });
        // ...
        */
      } else {
        // User is signed out.
        // ...
       // console.log( "signed out" );
        // store.dispatch( userActions.replaceUser( new User() ) );
        Globals.FirebaseInstance.clearListeners();

        Globals.Storage.RemoveLocal( Globals.FIREBASE_HAS_ACCOUNT);
        if ( Globals.FirebaseInstance.Callback && Globals.FirebaseInstance.Callback.AuthStatusChanged )
        {
          Globals.FirebaseInstance.Callback.AuthStatusChanged();
        }
      }
      // ...

      // store.dispatch( dialogActions.closeLogIn() );
    });
  }

  clearListeners = () =>
  {
    if ( this.clientResponseListener )
      {
        this.clientResponseListener();
        this.clientResponseListener = null;
      }
/*
      if ( this.userRoomsRef && this.userRoomsListener)
      {
        this.userRoomsRef.off('value', this.userRoomsListener );
        this.userRoomsListener = null;
        this.userRoomsRef = null;
      }
        */
  }


  AddChatListeners = ( uid ) => {

  var database = Globals.FirebaseApp.database();


    // Create a reference to the path you want to listen to
    // Limit to last 50 entries ordered by nested timestamp
    this.userRoomsRef = database.ref(`/userRooms/${uid}`)
      .orderByChild('lastMessage/timestamp')
      .limitToLast(50);

    // Create a reference WITH query for initial ordered data
    this.userRoomsRef = database.ref(`/userRooms/${uid}`)
      .orderByChild('lastMessage/timestamp')
      .limitToLast(50);

    // Create a separate reference WITHOUT query for listening to all changes
    this.userRoomsListener = database.ref(`/userRooms/${uid}`);

  // Use the queried reference for initial load
    this.userRoomsRef.once('value', (snapshot) => {
      // console.log('Initial load:', new Date().toISOString());

      // Handle the data here
      if (snapshot.exists()) {
        // Data exists - convert to array while preserving Firebase order
        this.roomsArray = [];
        snapshot.forEach((childSnapshot) => {
          this.roomsArray.push({
            id: childSnapshot.key,
            ...childSnapshot.val()
          });
        });

        // Reverse to get most recent first
        this.roomsArray.reverse();

        // console.log('Rooms loaded (most recent first):', this.roomsArray);
      } else {
        // No data at this location
        this.roomsArray = [];
        // console.log('No rooms found for this user');
      }

      // Mark as initialized
      this.isInitialized = true;

    }, (error) => {
      // Handle errors
      // console.error('Error reading data:', error);
    });

    // Use the unqueried reference for change listeners
    // Listen for child added events
    this.userRoomsListener.on('child_added', (snapshot) => {
      // Ignore during initial load
      if (! this.isInitialized || this.roomsArray === null) return;

      // console.log('Room added:', snapshot.key, snapshot.val());

      const index = this.roomsArray.findIndex(room => room.id === snapshot.key);
      if (index !== -1) {
        // Room already exists in array (shouldn't happen with proper Firebase rules)
        return;
      }
      // Add new room to the beginning of the array (most recent)
      this.roomsArray.unshift({
        id: snapshot.key,
        ...snapshot.val()
      });

      // Optional: Keep only last 50
      if (this.roomsArray.length > 50) {
        this.roomsArray.pop();
      }

      // console.log('Updated rooms array:', this.roomsArray);
    });

    // Listen for child changed events (THIS will fire for any room update)
    this.userRoomsListener.on('child_changed', (snapshot) => {
      // Ignore during initial load
      if (! this.isInitialized || this.roomsArray === null) return;

      // console.log('Room changed:', snapshot.key, snapshot.val());

      let snap = snapshot.val()
      // console.log( snap );
      if ( ! snap ) return;
      let msg = snap?.lastMessage;
      // console.log( msg );
      if ( ! msg ) return;

      // Find and update the room in the array
      const index = this.roomsArray.findIndex(room => room.id === snapshot.key);
      if (index !== -1) {
        this.roomsArray[index] = {
          id: snapshot.key,
          ...snapshot.val()
        };

        // Optional: Re-sort the array if timestamp changed
        // This keeps the array in correct order after updates
        this.roomsArray.sort((a, b) => {
          const timeA = a.lastMessage?.timestamp || 0;
          const timeB = b.lastMessage?.timestamp || 0;
          return timeB - timeA; // Most recent first
        });
      }
      // console.log('Updated rooms array:', this.roomsArray);

       let notification = DashboardNotification.CreateFromChat( msg );

        if ( notification )
        {
          store.dispatch( notificationActions.addNotification( notification ) );
        }
    });

    // Listen for child removed events
    this.userRoomsListener.on('child_removed', (snapshot) => {
      // Ignore during initial load
      if (! this.isInitialized || this.roomsArray === null) return;

      // console.log('Room removed:', snapshot.key);

      // Remove the room from the array
      const index = this.roomsArray.findIndex(room => room.id === snapshot.key);
      if (index !== -1) {
        this.roomsArray.splice(index, 1);
      }

      // console.log('Updated rooms array:', this.roomsArray);
    });
  }

    AddShortlistListeners = () =>
    {

      this.clearListeners();
      let db = Globals.FirebaseApp.firestore();

      let user = User.CurrentUser();

      if ( ! user.FirebaseUid || user.FirebaseUid.length === 0 )
      {
        return;
      }

      let This = this;

      let path = "notifications/" + user.FirebaseUid + "/submissions"
      this.clientResponseListener = db.collection( path )
      .onSnapshot(function(snapshot) {
        snapshot.docChanges().forEach(function(change) {

          let data = change.doc.data();
          let uid = change.doc.id;
          // console.log( "DATA", data );
          switch( change.type )
          {
            case "modified":
            case "added":

              let sub = { submission_id: uid, status: parseInt(data.s) }
              let date = new Date();
              if ( data.d )
              {
                date = data.d.toDate();
              }
              sub.date = date.getTime()/1000;
              data.submission_id = uid;
              data.date = data.d.toDate().getTime();
              // update interface
              store.dispatch( shortlistActions.updateStatus( sub ));
              // This.deleteSubmissionNotifications( uid );
              // create a notification
              let notification = DashboardNotification.Create( uid, data );

              if ( notification )
              {
                store.dispatch( notificationActions.addNotification( notification ) );
              }
              //console.log( notification );
              //console.log( sub )
              break;

              default: break;
          }
        });
      });
  }

  deleteSubmissionNotifications = ( submission_id ) => {

    let db = Globals.FirebaseApp.firestore();
    let user = User.CurrentUser();

    if ( ! user.FirebaseUid || user.FirebaseUid.length === 0 )
    {
      return;
    }
    if ( ! submission_id || isNaN( submission_id ) )
    {
      return;
    }
    let doc = db.collection("notifications/" + user.FirebaseUid + "/submissions/").doc( submission_id );
    if ( doc )
    {
      doc.delete();
    }
  }



    SignOut = () =>
    {
     // console.log( "sign out" );
        app.auth().signOut();
    }

  LogInAnonymously = () =>
  {
    // console.log( "anon log in" );
    app.auth().signInAnonymously().catch(function(error) {
    // Handle Errors here.
    //var errorCode = error.code;
    //var errorMessage = error.message;
    // ...
    })
  }

  LogInWithCustomToken = ( token ) => {

    app.auth().signOut().then(() => {
        app.auth().signInWithCustomToken(token)
        .then((userCredential) => {
          // Signed in
         // console.log( userCredential )
          // ...
          let user = User.CurrentUser();
          user.FirebaseUid = userCredential.user.uid;
        })
        .catch((error) => {
//          var errorCode = error.code;
  //        var errorMessage = error.message;

          // console.log( errorCode, errorMessage );
          // ...
        })
      }
    ).catch( (error) => {

    })
  }


  PushMessagingSupported = () => {

    if ( ! app || ! app.messaging || ! app.messaging.isSupported() )
    {
      return false
    }
    return true;
  }


  StartPushNotifications = ( topics ) => {

     // console.log( "fb StartPushNotifications")
      if ( this.messaging )
      {
        this.messaging.StartPushNotifications( topics );
      }
    }
/*
    SubscribeToPushNotifications = ( subscribe ) => {
      if ( this.messaging )
      {
        this.messaging.SubscribeToNotifications( true );
      }
    }
*/
    StopPushNotifications = () => {

      // console.log( "StopPushNotifications", this.messaging )
      // messaging registration my not have taken place if anonymous user, so may need to register it so can unregister it from a previous user
      if ( ! this.messaging )
      {
        if ( Globals.FirebaseInstance.PushMessagingSupported() )
        {
          Globals.FirebaseInstance.messaging = new FirebaseMessaging(app, vapidKey, false );
        }
      }
      if ( this.messaging )
      {
        this.messaging.StopPushNotifications();
      }
    }
/*

  InitPushMessaging = () => {

    if ( ! app.messaging.isSupported() )
    {
      return;
    }
    messaging = app.messaging();

    messaging.getToken( { vapidKey: vapidKey} )
    .then( ( messagingToken ) => {
      if ( messagingToken )
      {
        console.log( "token" , messagingToken );
      }
      else
      {
        console.log('No registration token available. Request permission to generate one.');
      }
    } )
    .catch( ( err ) => {
      console.log('An error occurred while retrieving token. ', err);
    } );

    messaging.onMessage((payload) => {
      console.log('foreground Message received. ', payload);
      // ...

      const notificationTitle = payload.notification.title;
      const notificationOptions = {
        body: payload.notification.body,
        silent: true,
        icon: "./logo192.png"
      };
        const notification = new Notification(notificationTitle, notificationOptions );
    });


  }
*/

  /*
  function requestPermission() {
    console.log('Requesting permission...');
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        console.log('Notification permission granted.');
        // TODO(developer): Retrieve a registration token for use with FCM.
        // In many cases once an app has been granted notification permission,
        // it should update its UI reflecting this.
        resetUI();
      } else {
        console.log('Unable to get permission to notify.');
      }
    });
  }

  function deleteToken() {
    // Delete registration token.
    messaging.getToken().then((currentToken) => {
      messaging.deleteToken(currentToken).then(() => {
        console.log('Token deleted.');
        setTokenSentToServer(false);
        // Once token is deleted update UI.
        resetUI();
      }).catch((err) => {
        console.log('Unable to delete token. ', err);
      });
    }).catch((err) => {
      console.log('Error retrieving registration token. ', err);
      showToken('Error retrieving registration token. ', err);
    });
  }
  */


  componentDidMount() {

  }



    render () {

      if (this.state.redirect) {
        return <Redirect to={this.state.redirect} />
    }
      return null;

    }

}
export default Firebase;